// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Store from './store/Store'
import ElementUI from 'element-ui'
import Vuex from 'vuex'
import axios from 'axios'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import '../static/css/global.css'
import './assets/css/common.css'

Vue.use(ElementUI)
// // import {
// //   Pagination,
// //   Dialog,
// //   Menu,
// //   MenuItem,
// //   Input,
// //   Table,
// //   TableColumn,
// //   DatePicker,
// //   TimeSelect,
// //   TimePicker,
// //   Button,
// //   Breadcrumb,
// //   BreadcrumbItem,
// //   Form,
// //   FormItem,
// //   Row,
// //   Col,
// //   Upload,
// //   Container,
// //   Header,
// //   Aside,
// //   Main,
// //   Footer,
// //   Loading,
// //   Message,
// //   Tooltip,
// //   // Autocomplete,
// //   // DropdownMenu,
// //   // Dropdown,
// //   // DropdownItem,
// //   // Submenu,
// //   // MenuItemGroup,
// //   // InputNumber,
// //   Radio,
// //   RadioGroup,
// //   RadioButton,
// //   // Checkbox,
// //   // CheckboxButton,
// //   CheckboxGroup,
// //   // Switch,
// //   Select,
// //   Option,
// //   // OptionGroup,
// //   Popover,
// //   // Tabs,
// //   // TabPane,
// //   // Tag,
// //   // Tree,
// //   Alert,
// //   // Slider,
// //   // Progress,
// //   // Badge,
// //   Card,
// //   Image,
// //   // Rate,
// //   // Steps,
// //   // Step,
// //   Carousel,
// //   CarouselItem,
// //   // Collapse,
// //   // CollapseItem,
// //   // Cascader,
// //   // ColorPicker,
// //   // Transfer,
// //   MessageBox
// //   // Notification
// // } from 'element-ui'
// // Vue.use(Transfer)
// Vue.use(Pagination)
// Vue.use(Dialog)
//
// // Vue.use(Autocomplete)
// // Vue.use(Dropdown)
// // Vue.use(DropdownMenu)
// // Vue.use(DropdownItem)
// Vue.use(Menu)
// // Vue.use(Submenu)
// Vue.use(MenuItem)
// // Vue.use(MenuItemGroup)
// Vue.use(Input)
// // Vue.use(InputNumber)
// Vue.use(Radio)
// Vue.use(RadioGroup)
// Vue.use(RadioButton)
// // Vue.use(Checkbox)
// // Vue.use(CheckboxButton)
// Vue.use(CheckboxGroup)
// // Vue.use(Switch)
// Vue.use(Select)
// Vue.use(Option)
// // Vue.use(OptionGroup)
// Vue.use(Button)
// // Vue.use(ButtonGroup)
// Vue.use(Table)
// Vue.use(TableColumn)
// Vue.use(DatePicker)
// Vue.use(TimeSelect)
// Vue.use(TimePicker)
// Vue.use(Popover)
// Vue.use(Tooltip)
// Vue.use(Breadcrumb)
// Vue.use(BreadcrumbItem)
// Vue.use(Form)
// Vue.use(FormItem)
// Vue.use(Image)
//
// // Vue.use(Tabs)
// // Vue.use(TabPane)
// // Vue.use(Tag)
// // Vue.use(Tree)
// Vue.use(Alert)
// // Vue.use(Slider)
// // Vue.use(Icon)
// Vue.use(Row)
// Vue.use(Col)
// Vue.use(Upload)
// // Vue.use(Progress)
// // Vue.use(Badge)
// Vue.use(Card)
// // Vue.use(Rate)
// // Vue.use(Steps)
// // Vue.use(Step)
// Vue.use(Carousel)
// Vue.use(CarouselItem)
// // Vue.use(Collapse)
// // Vue.use(CollapseItem)
// // Vue.use(Cascader)
// // Vue.use(ColorPicker)
// Vue.use(Container)
// Vue.use(Header)
// Vue.use(Aside)
// Vue.use(Main)
// Vue.use(Footer)
//
// Vue.use(Loading.directive)


// Vue.prototype.$msgbox = MessageBox
// Vue.prototype.$alert = MessageBox.alert
// Vue.prototype.$confirm = MessageBox.confirm
// Vue.prototype.$prompt = MessageBox.prompt
// Vue.prototype.$message = Message

function getCookies(name) {
  try {
    let o = JSON.parse(localStorage[name])
    if (!o || o.expires < Date.now()) {
      return null
    } else {
      return o.value
    }
  } catch (e) {
    // 兼容其他localstorage
    return localStorage[name]
  } finally {}
}
Vue.prototype.mediaToken = 'mediaToken'
Vue.prototype.mediaUid = 'mediaUid'
Vue.prototype.mediaUsername = 'mediaUsername'
Vue.prototype.mediaCompany = 'mediaCompany'
Vue.prototype.getCookies = getCookies
Vue.use(Vuex)
const store = new Vuex.Store(Store)
Vue.config.productionTip = false
Vue.prototype.$axios = axios
// 配置通知接口
Vue.prototype.noticeApi = function() {
  this.$axios({
    method: 'post',
    url: this.$store.state.mediaUrl + '/api/adsystem/media/notification/icon',
    data: {
      token: this.getCookies(this.mediaToken),
      mediaids: this.getCookies(this.mediaUid),
      mediaNoticRead: 2
    }
  }).then(response => {
    this.loadding = false
    if (response.data.success) {
      let num = 0
      console.log(response.data)
      response.data.result.length === 0 ? this.$store.state.shownoc = false : this.$store.state.shownoc = true
      if (this.$store.state.shownoc) {
        response.data.result.map(value => {
          if (value.media_notic_read === 2) {
            num += 1
          }
        })
      }
      this.$store.commit('setNotic', num)
    } else {
      this.$store.commit('setToken', null)
      this.$router.push('/login')
    }
  })
}
Vue.prototype.formatLgNum=(num)=>{
  return Math.floor(num * 100) / 100
}

/* eslint-disable no-new */
let vueInstance = null

axios.interceptors.request.use(
    config => {
        if (getCookies('mediaToken')) { // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers["authentication-token"] = getCookies('mediaToken');
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);
axios.interceptors.response.use(
    response => {
        if (response.data.code && response.data.code === 401) {
            if (vueInstance) {
                vueInstance.$router.push('/login')
            }
        }
        return response;
    });

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    if (getCookies('mediaToken') != null) {

        next()
    } else {
      next({
        path: '/login'
        // query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
      return false
    }
  } else {
    // next({path: '/login',query: {redirect: to.fullPath}});
    next()
  }
})
/*
配置图片在固定的宽高容器里等比例缩放
*/
function AutoSize(listImg, maxWidth, maxHeight) {
  // 原图片原始地址（用于获取原图片的真实宽高，当<img>标签指定了宽、高时不受影响）
  for (let i = 0; i < listImg.length; i++) {
    let image = new Image()
    // 获取每一个图片的宽高
    image.src = listImg[i].src
    // 监听图片加载事件，当加载完成之后再设置宽高
    image.addEventListener('load', () => {
      // 当图片比图片框小时不做任何改变
      if (image.width < maxWidth && image.height < maxHeight) {
        // 原图片宽高比例 大于 图片框宽高比例
        listImg[i].width = 100
        listImg[i].height = 100
      } else {
        // 原图片宽高比例 大于 图片框宽高比例,则以框的宽为标准缩放，反之以框的高为标准缩放
        if (maxWidth / maxHeight <= image.width / image.height) {
          listImg[i].width = maxWidth // 以框的宽度为标准
          listImg[i].height = maxWidth * (image.height / image.width)
        } else {
          listImg[i].width = maxHeight * (image.width / image.height)
          listImg[i].height = maxHeight // 以框的高度为标准
        }
      }
    })
    // 如果不是第一次加载
    // 当图片比图片框小时不做任何改变
    if (image.width < maxWidth && image.height < maxHeight) {
      // 原图片宽高比例 大于 图片框宽高比例
      listImg[i].width = 100
      listImg[i].height = 100
    } else {
      // 原图片宽高比例 大于 图片框宽高比例,则以框的宽为标准缩放，反之以框的高为标准缩放
      if (maxWidth / maxHeight <= image.width / image.height) {
        listImg[i].width = maxWidth // 以框的宽度为标准
        listImg[i].height = maxWidth * (image.height / image.width)
      } else {
        listImg[i].width = maxHeight * (image.width / image.height)
        listImg[i].height = maxHeight // 以框的高度为标准
      }
    }
  }
}
// 考虑 IE 的兼容性
function getStyle(el) {
  if (window.getComputedStyle) {
    return window.getComputedStyle(el, null)
  } else {
    return el.currentStyle
  }
}
// 通过当前元素获取宽高
function getWidHei(el, name) {
  let val = name === 'width' ? el.offsetWidth : el.offsetHeight
  let which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom']
  // display is none
  if (val === 0) {
    return 0
  }
  let style = getStyle(el)
  // 左右或上下两边的都减去
  for (let i = 0, a;
    (a = which[i++]);) {
    val -= parseFloat(style['border' + a + 'Width']) || 0
    val -= parseFloat(style['padding' + a]) || 0
  }
  return val
}

Date.prototype.format = function() {
    var s = '';
    var mouth = (this.getMonth() + 1)>=10?(this.getMonth() + 1):('0'+(this.getMonth() + 1));
    var day = this.getDate()>=10?this.getDate():('0'+this.getDate());
    s += this.getFullYear() + '-'; // 获取年份。
    s += mouth + "-"; // 获取月份。
    s += day; // 获取日。
    return (s); // 返回日期。
};
Date.prototype.format2 = function() {
  var s = '';
  var mouth = (this.getMonth() + 1)>=10?(this.getMonth() + 1):('0'+(this.getMonth() + 1));
  var day = this.getDate()>=10?this.getDate():('0'+this.getDate());
  s += this.getFullYear() + '-'; // 获取年份。
  s += mouth + "-"; // 获取月份。
  s += day; // 获取日。
  var c = ""+this.getHours()>=10?this.getHours():('0'+this.getHours());
  s = s+ " "+c;
  return (s); // 返回日期。
};
function initImgRect(className) {
  setTimeout(() => {
    // 获取所有的img标签
    let imgList = document.querySelectorAll(className)
    // 获取父元素宽高
    let parentWh = imgList[0].parentNode
    let wid = getWidHei(parentWh, 'width')
    let hei = getWidHei(parentWh, 'height')
    // 等比压缩图片
    AutoSize(imgList, wid, hei)
  }, 100)
}
Vue.prototype.initImgRect = initImgRect
/* eslint-disable no-new */
vueInstance = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



function setCookies (key, value) {
  // 设置过期原则
  if (!value) {
    localStorage.removeItem(key)
  } else {
    var exp = new Date()
    localStorage[key] = JSON.stringify({
      value,
      expires: exp.getTime() + 1000 * 60 * 60 * 24 * 3
    })
  }
}

function delCookies (key) {
  // 设置过期原则
  if (key) {
    localStorage.removeItem(key)
  }
}

Vue.prototype.setCookies = setCookies;
Vue.prototype.delCookies = delCookies;



// WEBPACK FOOTER //
// ./src/main.js